var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9992 16.0434C10.5871 16.0434 6.99609 12.4524 6.99609 8.04025C6.99609 3.62808 10.5871 0.0371094 14.9992 0.0371094C19.4114 0.0371094 23.0024 3.62808 23.0024 8.04025C23.0024 12.4524 19.4114 16.0434 14.9992 16.0434ZM14.9992 2.12489C11.7423 2.12489 9.08387 4.78332 9.08387 8.04025C9.08387 11.2972 11.7423 13.9556 14.9992 13.9556C18.2562 13.9556 20.9146 11.2972 20.9146 8.04025C20.9146 4.78332 18.2562 2.12489 14.9992 2.12489Z",
    fill: "#E9A5F3",
    fillOpacity: 0.952941
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9558 29.9616C26.3851 29.9616 25.9119 29.4884 25.9119 28.9177C25.9119 24.1158 21.0127 20.2186 14.9999 20.2186C8.98708 20.2186 4.08778 24.1158 4.08778 28.9177C4.08778 29.4884 3.61455 29.9616 3.04389 29.9616C2.47323 29.9616 2 29.4884 2 28.9177C2 22.9745 7.83184 18.1309 14.9999 18.1309C22.168 18.1309 27.9997 22.9745 27.9997 28.9177C27.9997 29.4884 27.5265 29.9616 26.9558 29.9616Z",
    fill: "#E9A5F3",
    fillOpacity: 0.952941
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.c53efce0fc5450ac42988352df1cd899.svg";
export { ForwardRef as ReactComponent };